import axios, { AxiosResponse } from 'axios';

export type RefreshTokenType = () => Promise<AxiosResponse<string>>;

export const refreshToken: RefreshTokenType = async () => {
  const res = await axios.post<string>(
    `https://${process.env.REACT_APP_API_BASE_URL}/aaa/Prod/refreshTokens`,
    {},
    {
      withCredentials: true,
    },
  );
  return res;
};
